export default "__VITE_ASSET__mmopbnaR__"